import React, {Component} from 'react';
import { connect } from 'react-redux';
import { Row, Col, Container} from 'react-bootstrap';
import WiderImage from '../components/wider-image';
import SectionHeading from '../components/section-heading';

import { fetchCaseStudyById } from '../redux/actions/actions';  

class GalleryDetails extends Component {
  async componentDidMount() {
    let { loadArticleById, match:{params:{articleId}} } = this.props;
    await loadArticleById(articleId);
  }
  render() {
    return(
      <div className="le-gallery-details">
      {
        this.props.article?this.props.article.map((data, index) => (
          <>
            <WiderImage image={data.images.headerImage} alt="header"/>
            <Container className="content">
              <Row className="info-box">
                <Col className="client-name">
                  <p>CLIENT</p>
                  <h5>{data.clientName}</h5>
                </Col>
                <Col className="client-name">
                  <p>CATEGORY</p>
                  <div className="tag-container">
                    {
                      data.tags.length?data.tags.map((tag, index) => (
                      <span className="tags" key={`tag${index}`}>{tag}</span>
                      )):'No tags'
                    }
                    
                  </div>
                </Col>
                <Col className="client-name">
                  <p>DATE</p>
                  <h5>{data.date}</h5>
                </Col>
              </Row>
              <SectionHeading subText="CASE STUDY" heading={data.title} align="heading-center"/>
              {/* dangerouslySetInnerHTML={{__html: data.content}} */}
              <div className="gallery-content" dangerouslySetInnerHTML={{__html: data.content}}>
                
              </div>
            </Container>
          </>
        )): 'no data'
      }
      </div>
    )
  }
}

const mapStateToProps = ({linenedges}) => ({
  article: linenedges.openedCaseStudy
})

const mapDispatchToProps = dispatch => ({
  loadArticleById: async (articleId) => await dispatch(fetchCaseStudyById(articleId))
}) 
export default connect(mapStateToProps, mapDispatchToProps)(GalleryDetails);